import React from 'react';
import { BookOpenIcon } from 'lucide-react';
export function BrandHeader() {
  return <header className="w-full border-b border-line bg-canvas" data-id="element-44" data-mp="1ocdok5b5weda">
      <div className="mx-auto flex max-w-page items-center justify-center gap-2 px-5 py-4" data-id="element-45" data-mp="1ocx45fdcaqo5">
        <BookOpenIcon className="h-4 w-4 text-flame" aria-hidden="true" data-id="element-46" data-mp="1jjkk7ijlv81q" />
        <span className="font-display text-[17px] font-black tracking-tight text-night" data-id="element-47" data-mp="1elaq7b9madhp">
          Librofy.Store<sup className="ml-0.5 align-super text-[9px] font-bold" data-id="element-48" data-mp="19o0pv0kowhf3">™</sup>
        </span>
      </div>
    </header>;
}